export default {
  STORAGE_KEY_TOKEN: 'Aden0x0000',
  STORAGE_KEY_REFRESH_TOKEN: 'Aden0x0001',
  STORAGE_USER_INFO: 'Aden0x0002',
  STORAGE_KEY_ROUTE_FULL_PATH: 'Aden0x0003',
  STORAGE_KEY_NAME: 'Aden0x0004',
  STORAGE_KEY_PASSWORD: 'Aden0x0005',
  STORAGE_USER_MENUS: 'Aden0x0006',
  STORAGE_KEY_STATUS: 'Aden0x0007',
  STORAGE_KEY_USER_NAME: 'Aden0x0008',
  STORAGE_KEY_ACCOUNT_ID: 'Aden0x0009',
  STORAGE_KEY_BUSINESS_LIST: 'Aden0x0010',
  STORAGE_KEY_EXPIRE_TIME: 'Aden0x0011',
  STORAGE_KEY_SERVER_TIME: 'Aden0x0018',
  STORAGE_KEY_BAR_ID: 'Aden0x0012',
  STORAGE_KEY_PERMISSIONS: 'Aden0x0013',
  STORAGE_KEY_OPEN_ID: 'Aden0x0014',
  STORAGE_KEY_PRIZE_TYPE_LIST: 'Aden0x0015',
  STORAGE_KEY_PERSONAL_INFO: 'Aden0x0016',
  STORAGE_KEY_LOGIN_TYPE: 'Aden0x0017',
  STORAGE_KEY_LOGIN_CHAIN_ID: 'Aden0x0018',
  STORAGE_KEY_PRODUCT_TYPE: 'Aden0x0019',
  STORAGE_KEY_GAME_LIFE_ACCOUNT: 'Aden0x0020',
};
